module.exports = __webpack_public_path__ + "static/media/logo_verde_vertical.d297519a.png";